import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Instagram, MessageCircle, Mail, Phone } from "lucide-react";
import SEO from "../components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) { toast.error("Fill all fields."); return; }
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent. We'll get back soon.");
      setForm({ name: "", email: "", message: "" });
    } catch { toast.error("Couldn't send. Try WhatsApp."); }
    finally { setSending(false); }
  };
  return (
    <>
      <SEO title="Contact" />
      <section className="max-w-5xl mx-auto px-6 py-16">
        <p className="font-mono-cap text-[10px] text-white/40">Contact</p>
        <h1 className="font-serif text-5xl sm:text-6xl mt-2">Talk to us.</h1>
        <div className="grid lg:grid-cols-2 gap-12 mt-12">
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="contact-name" placeholder="Your name" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} className="w-full bg-transparent border border-white/15 px-3 py-3 text-sm focus:outline-none focus:border-white" />
            <input data-testid="contact-email" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} className="w-full bg-transparent border border-white/15 px-3 py-3 text-sm focus:outline-none focus:border-white" />
            <textarea data-testid="contact-message" rows={5} placeholder="Your message" value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} className="w-full bg-transparent border border-white/15 px-3 py-3 text-sm focus:outline-none focus:border-white" />
            <button data-testid="contact-submit" disabled={sending} className="bg-white text-black font-mono-cap text-xs px-8 py-4 hover:bg-white/90 disabled:opacity-50">{sending ? "Sending..." : "Send Message"}</button>
          </form>
          <div className="space-y-4">
            <a href="mailto:thedripchexk@gmail.com" className="flex items-center gap-3 border border-white/15 p-5 hover:bg-white/5"><Mail size={18} /><span>thedripchexk@gmail.com</span></a>
            <a href="tel:+918383862206" className="flex items-center gap-3 border border-white/15 p-5 hover:bg-white/5"><Phone size={18} /><span>+91 8383862206</span></a>
            <a href="https://wa.me/918383862206" target="_blank" rel="noreferrer" className="flex items-center gap-3 border border-white/15 p-5 hover:bg-white/5"><MessageCircle size={18} /><span>WhatsApp us</span></a>
            <a href="https://instagram.com/thedripchexk" target="_blank" rel="noreferrer" className="flex items-center gap-3 border border-white/15 p-5 hover:bg-white/5"><Instagram size={18} /><span>@thedripchexk</span></a>
          </div>
        </div>
      </section>
    </>
  );
};
export default Contact;
